/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

/** CreateAuthResetsRequest — dark-roast DTO: AuthResetTokenPostDto */
export const createAuthResetsRequestSchema = z.object({ "email": z.string().min(1).email(), "RelayState": z.string().nullish() });
export type CreateAuthResetsRequest = z.infer<typeof createAuthResetsRequestSchema>;
